module.exports = __webpack_public_path__ + "img/life-full.c4a1caa2.svg";